module.exports = __webpack_public_path__ + "img/Path 23@3x.81869a7b.png";